<template>
  <div>
    <div class="page-content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-head">
            商品分类
            <div class="search-input">
              <Input v-model="cxName" size="small" placeholder="请输入名称搜索" search />
            </div>
          </div>
          <div class="card-body padding-top0">
            <div class="card-menu">
              <Button type="primary" icon="md-add" @click="addClick" style="margin-right: 10px">新增</Button>
              <Button type="error" icon="md-trash" @click="allDel" :loading="loading"
                :disabled="Selection.length==0?true:false">删除所选</Button>
            </div>
            <div v-if="data.length == 0 && !load">
              <Empty :text="'暂无数据'"></Empty>
            </div>
            <div v-else>
              <Alert show-icon v-if="$store.state.isMobile">移动设备请左右滑动翻阅</Alert>
              <Table ref="selection" border :loading="load" :columns="columns" :data="data" @on-selection-change="handleSelectChange">
                <template slot-scope="{ row }" slot="status">
                  <Badge v-if="row.status === 0" status="error" text="已停用" />
                  <Badge v-if="row.status === 1" status="success" text="已启用" />
                </template>
                <template slot-scope="{ row }" slot="action">
                  <Button type="primary" size="small" style="margin-right: 5px" @click="editClick(row)">编辑</Button>
                  <Button type="error" size="small" @click="del(row.id)">删除</Button>
                </template>
              </Table>
              <div class="paging">
                <Page :total="Number(total)" :current="pageIndex" :page-size="pageSize" :simple="$store.state.isMobile"
                  @on-change="pageChange" @on-page-size-change="pageSizeChange" show-total show-sizer show-elevator />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Modal v-model="showCreate" :title="edit ? '编辑分类' : '新增分类'" :loading="creating"
      @on-ok="edit ? editSave() : addSave()">
      <Form ref="create" :model="createData" :rules="createRules" :label-width="100">
        <FormItem label="分类名称：" prop="name">
          <Input v-model="createData.name" placeholder="请输入名称" />
        </FormItem>
        <FormItem label="排序：" prop="weight">
          <InputNumber v-model="createData.weight" :max="9999" :min="1" placeholder="请输入排序" style="width: 70%">
          </InputNumber>
          <Tooltip content="数值越大越靠前" placement="bottom-end">
            <span class="iconfont icon-wenhao help"></span>
          </Tooltip>
        </FormItem>
        <FormItem label="状态：" prop="status">
          <i-switch v-model="createData.status" :true-value="1" :false-value="0" />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
  import {
    postGroup,
    getGroup,
    delGroup,
    putGroup
  } from "@/api/admin";

  export default {
    data() {
      return {
        Selection: [],
        pageIndex: 1,
        pageSize: 10,
        total: "",
        cxName: "",
        showCreate: false,
        creating: true,
        loading: false,
        edit: false,
        createData: {
          name: "",
          weight: 0,
          status: 1,
        },
        createRules: {
          name: [{
            required: true,
            message: "请输入名称",
            trigger: "blur"
          }],
        },
        columns: [{
            type: "selection",
            width: 60,
            align: "center",
          },
          {
            title: "名称",
            key: "name",
            minWidth: 200,
          },
          {
            title: "排序",
            key: "weight",
            align: "center",
            sortable: true,
            minWidth: 100,
          },
          {
            title: "操作时间",
            key: "addtime",
            align: "center",
            minWidth: 200,
          },
          {
            title: "状态",
            align: "center",
            slot: "status",
            minWidth: 100,
          },
          {
            title: "操作",
            minWidth: 130,
            align: "center",
            slot: "action",
          },
        ],
        data: [],
        load:true
      };
    },
    created() {
      this._getData();
    },
    watch: {
      cxName(newVal, oldVal) {
        if (newVal != oldVal) {
          this.pageIndex = 1
          this.load = true
          this._getData();
        }
      },
    },
    methods: {
      // 获取列表
      _getData() {
        getGroup({
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          name: this.cxName,
        }).then((res) => {
          this.data = res.data.data;
          this.total = res.data.total;
          this.Selection = [];
          this.load = false
        });
      },
      // 删除
      del(id) {
        this.$Modal.confirm({
          title: "删除确认",
          content: "删除分类会同时删除分类下的商品、规格以及库存，删除后无法恢复，是否继续？",
          onOk: () => {

            this.delFunction(id);
          },
        });
      },
      // 删除所选
      allDel() {
        let arr = [];
        this.Selection.map(function (item) {
          arr.push(item.id);
        });
        this.del(arr);
      },
      // 删除方法
      delFunction(id) {
        this.loading = true
        this.load = true
        delGroup({
          id: id,
        }).then((res) => {
          if (res.code == 200) {
            this.$Message.success({
              background: true,
              content: res.msg,
            });
            this._getData();
          } else {
            this.$Message.error({
              background: true,
              content: res.msg,
            });
          }
          this.loading = false
          this.Selection = [];
        });
      },

      //  新增按钮
      addClick() {
        this.edit = false;
        this.showCreate = true;
      },

      // 新增方法
      addSave() {
        this.$refs.create.validate((valid) => {
          if (valid) {
            postGroup({
              name: this.createData.name,
              weight: this.createData.weight,
              status: this.createData.status,
            }).then((res) => {
              if (res.code == 200) {
                this.$Message.success({
                  background: true,
                  content: res.msg,
                });
                this._getData();
                this.createData.name = "";
                this.createData.weight = 0;
                this.createData.status = 1;
              } else {
                this.$Message.error({
                  background: true,
                  content: res.msg,
                });
              }
            });
            this.showCreate = false;
            this.creating = false;
            this.$nextTick(() => {
              this.creating = true;
            });
          } else {
            this.creating = false;
            this.$nextTick(() => {
              this.creating = true;
            });
          }
        });
      },

      //  编辑按钮
      editClick(row) {
        this.edit = true;
        this.showCreate = true;
        this.createData = {
          ...row
        };
      },

      // 编辑方法
      editSave() {
        this.$refs.create.validate((valid) => {
          if (valid) {
            putGroup({
              id: this.createData.id,
              name: this.createData.name,
              weight: this.createData.weight,
              status: this.createData.status,
            }).then((res) => {
              if (res.code == 200) {
                this.$Message.success({
                  background: true,
                  content: res.msg,
                });
                this._getData();
                this.createData.name = "";
                this.createData.weight = 0;
                this.createData.status = 1;
              } else {
                this.$Message.error({
                  background: true,
                  content: res.msg,
                });
              }
            });
            this.showCreate = false;
            this.creating = false;
            this.$nextTick(() => {
              this.creating = true;
            });
          } else {
            this.creating = false;
            this.$nextTick(() => {
              this.creating = true;
            });
          }
        });
      },
      // 分页跳转
      pageChange(val) {
        this.pageIndex = val;
        this.load = true
        this._getData();
      },
      pageSizeChange(val) {
        this.load = true
        this.pageIndex = 1;
        this.pageSize = val;
        this._getData();
      },
      //多选
      handleSelectChange(val) {
        this.Selection = val;
      },
    },
  };
</script>

<style lang="less" scoped>
 
</style>